import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scan-cv',
  templateUrl: './scan-cv.component.html',
  styleUrls: ['./scan-cv.component.css'],
})
export class ScanCvComponent implements OnInit {
  userLang: any = 'en';
  jobTitle: string = '';
  objective: string = '';

  services = [
    {
      color: 'blue',
      img: '../../../assets/icon/paper.png',
      title: 'Format',
      description: [
        'File format and size',
        'Resume length',
        'Long bullet points with suggestions on how to shorten',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/img.png',
      title: 'Resume sections',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/pen.png',
      title: 'Resume sections',
      description: [
        'Contact information',
        'Essential sections',
        'Personality showcase with tips on how to improve',
      ],
    },
    {
      color: 'pink',
      img: '../../../assets/icon/lamp.png',
      title: 'Resume sections',
      description: ['Contact information', 'Essential sections'],
    },
    {
      color: 'blue',
      img: '../../../assets/icon/a.png',
      title: 'Style',
      description: [
        'Resume design',
        'Email address',
        'Usage of active voice',
        'Usage of buzzwords and cliches',
      ],
    },
  ];

  steps: MenuItem[] = [];
  activeIndex: any = 0;
  cv: any = '';

  constructor(private translate: TranslateService, private router: Router) {
    this.getTranslate();
    this.translate.onLangChange.subscribe(() => {
      this.getTranslate();
    });
  }

  @ViewChild('stepsSection') stepsSection!: ElementRef;
  ngOnInit(): void {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLang = event.lang;
    });
  }

  getTranslate() {
    this.translate
      .get(['Upload Resume', 'Job Description', 'Result'])
      .subscribe((translations) => {
        this.steps = [
          { label: translations['Upload Resume'] },
          { label: translations['Job Description'] },
          { label: translations['Result'] },
        ];
      });
  }

  onCVDrop(event: any) {
    event.preventDefault();
    this.cv = event.dataTransfer.files[0];
    if (this.cv) {
      this.activeIndex = 1;
    }
  }

  onCVSelected(event: any) {
    this.cv = event.target.files[0];
    if (this.cv) {
      this.activeIndex = 1;
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  nextStep() {
    if (this.activeIndex === 1) {
      this.navigate();
    }
  }
  scrollToSteps() {
    if (this.stepsSection && this.stepsSection.nativeElement) {
      this.stepsSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  navigate() {
    this.router.navigate(['/scan-cv-result'], {
      state: {
        data: this.cv,
        jobTarget: this.jobTitle,
        jobDescription: this.objective,
        lang: this.translate.currentLang
      },
    });
  }
}